"use client";

import { useMemo } from "react";
import { SectionEngagementTracker } from "@/components/analytics/section-engagement-tracker";
import { SectionTypes } from "@/lib/utils/analytics";

export function HomePageSectionAnalytics() {
  const sections = useMemo(
    () => [
      { sectionType: SectionTypes.HEADER_STRIP, selector: "#header-strip" },
      { sectionType: SectionTypes.HERO_BANNER, selector: "#hero-banner" },
      {
        sectionType: SectionTypes.NOT_ALL_TESTS_ARE_EQUAL,
        selector: "#how-it-works",
      },
      { sectionType: SectionTypes.STATS_SECTION, selector: "#stats-section" },
      {
        sectionType: SectionTypes.CONFIRM_WITH_REAL_DATA,
        selector: "#confirm-with-real-data",
      },
      { sectionType: SectionTypes.WHY_MEASURE_PDG, selector: "#why-measure-pdg" },
      { sectionType: SectionTypes.SIX_RIGHT_DAYS, selector: "#six-right-days" },
      {
        sectionType: SectionTypes.TRACK_ACTUAL_HORMONE_DATA,
        selector: "#track-actual-hormone-data",
      },
      { sectionType: SectionTypes.USE_CASE, selector: "#use-case" },
      { sectionType: SectionTypes.PRODUCT_TECH, selector: "#product-tech" },
      {
        sectionType: SectionTypes.PRODUCT_TECH_STORIES,
        selector: "#tech-stories",
      },
      { sectionType: SectionTypes.USER_REVIEW, selector: "#user-review" },
      {
        sectionType: SectionTypes.RECOMMENDED_BY_CLINICIANS,
        selector: "#recommended-by-clinicians",
      },
      {
        sectionType: SectionTypes.COMMUNITY_SECTION,
        selector: "#community-section",
      },
      {
        sectionType: SectionTypes.BLOG_SECTION,
        selector: "#blog-section",
        trackHorizontalScroll: true,
      },
    ],
    [],
  );

  return <SectionEngagementTracker sections={sections} />;
}
